export const easeOut = [0.22, 1, 0.36, 1] as const
export const menuEase = [0.16, 1, 0.3, 1] as const

/** Wait until a block is well into the viewport, not as soon as it peeks in. */
export const inView = {
  once: true,
  amount: 0.1,
  margin: "0px 0px -22% 0px",
} as const

export const fadeUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: inView,
  transition: { duration: 0.5, ease: easeOut },
} as const

export const fadeIn = {
  initial: { opacity: 0, y: 18 },
  whileInView: { opacity: 1, y: 0 },
  viewport: inView,
  transition: { duration: 0.45, ease: easeOut },
} as const

export const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.06, delayChildren: 0.04 },
  },
} as const

export const staggerItem = {
  hidden: { opacity: 0, y: 16 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.4, ease: easeOut },
  },
} as const
